module.exports = __webpack_public_path__ + "static/media/lcb_depot.d4db0e30.jpg";